import { render } from "./TimerButtons.vue?vue&type=template&id=d958c380&scoped=true"
import script from "./TimerButtons.vue?vue&type=script&lang=js"
export * from "./TimerButtons.vue?vue&type=script&lang=js"

import "./TimerButtons.vue?vue&type=style&index=0&id=d958c380&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d958c380"]])

export default __exports__